import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { BusinessModeToggleService } from '@features/business-mode-toggle/business-mode-toggle.service'

export const turnOnBusinessModeGuard = () => {
  (inject(BusinessModeToggleService)).turnOn()

  return inject(Router).createUrlTree(['/'])
}
